import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {
    CreateTenantRequest,
    TenantResponse,
    TenantsResponse,
    UpdateTenantRequest
} from "../../admin/tenants/models/tenant.model";

@Injectable({ providedIn: "root" })
export class TenantsApiService {
    private readonly http = inject(HttpClient);

    getTenant(tenantId: string): Observable<TenantResponse> {
        return this.http.get<TenantResponse>(`${environment.interactiveExperienceServiceUrl}/v1/tenants/${tenantId}`);
    }

    getTenants(size: number, cursor?: string | null): Observable<TenantsResponse> {
        let params = new HttpParams().set("size", size);
        if (cursor) {
            params = params.set("cursor", cursor);
        }
        return this.http.get<TenantsResponse>(`${environment.interactiveExperienceServiceUrl}/v1/admin/tenants`, {
            params
        });
    }

    // No size/cursor param, so this is a real getAll that doesn't use a hardcoded max size
    getAuthorizedTenants(): Observable<TenantResponse[]> {
        return this.http.get<TenantResponse[]>(`${environment.interactiveExperienceServiceUrl}/v1/tenants`);
    }

    createTenant(body: CreateTenantRequest): Observable<TenantResponse> {
        return this.http.post<TenantResponse>(`${environment.interactiveExperienceServiceUrl}/v1/admin/tenants`, body);
    }

    updateTenant(tenantId: string, body: UpdateTenantRequest): Observable<TenantResponse> {
        return this.http.put<TenantResponse>(
            `${environment.interactiveExperienceServiceUrl}/v1/admin/tenants/${tenantId}`,
            body
        );
    }
}
